import { InfoCarousel, InfoCarouselSlide } from 'components';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

export const SharedCarousel = () => {
  const infoCarousel = useSelector((state: RootState) => state.widget.cms.text.info_carousel);
  const slides: InfoCarouselSlide[] = infoCarousel.slides;
  const { display_time } = infoCarousel.settings;

  return <InfoCarousel slides={slides} displayTime={parseInt(display_time, 10)} />;
};
